import React from 'react';
import './SocialLinks.css';

const SocialLinks = ({ settings }) => {
    // Get social links from CMS settings, with fallbacks
    const socialLinks = settings?.data?.social_links || {};
    
    const socialMediaLinks = [
        { 
            name: 'Spotify', 
            handle: '@jxles',
            url: socialLinks.spotify || 'https://open.spotify.com/artist/1cG9a9nCkAJgfDkH5YfC1W', 
            icon: '🎵',
            platform: 'spotify',
            isActive: !!socialLinks.spotify
        },
        { 
            name: 'SoundCloud', 
            handle: 'jxles',
            url: socialLinks.soundcloud || 'https://soundcloud.com/itsjxles', 
            icon: '☁️',
            platform: 'soundcloud',
            isActive: !!socialLinks.soundcloud
        },
        { 
            name: 'Instagram', 
            handle: '@jxles',
            url: socialLinks.instagram || 'https://instagram.com/its_jxles', 
            icon: '📷',
            platform: 'instagram',
            isActive: !!socialLinks.instagram
        },
        { 
            name: 'Twitter', 
            handle: '@jxles',
            url: socialLinks.twitter || 'https://twitter.com/jxlesMusic', 
            icon: '🐦',
            platform: 'twitter',
            isActive: !!socialLinks.twitter
        },
        { 
            name: 'YouTube', 
            handle: '@jxles',
            url: socialLinks.youtube || 'https://youtube.com/@jxles', 
            icon: '�',
            platform: 'youtube',
            isActive: !!socialLinks.youtube
        },
        { 
            name: 'Bandcamp', 
            handle: 'jxles',
            url: socialLinks.bandcamp || 'https://jxles.bandcamp.com', 
            icon: '🎶',
            platform: 'bandcamp',
            isActive: !!socialLinks.bandcamp
        },
    ].filter(link => link.isActive); // Only show active social links

    return (
        <section className="social-links">
            <div className="social-links__container">
                <div className="social-links__header">
                    <h2 className="social-links__title">Communication Array</h2>
                    <p className="social-links__subtitle">Tactical Network Connections</p>
                </div>

                <div className="social-links__grid">
                    {socialMediaLinks.map((link) => (
                        <a 
                            key={link.name} 
                            href={link.url} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className={`social-link social-link--${link.platform}`}
                        >
                            <div className="social-link__icon">
                                {link.icon}
                            </div>
                            <div className="social-link__content">
                                <div className="social-link__name">{link.name}</div>
                                <div className="social-link__handle">{link.handle}</div>
                            </div>
                            {link.isActive && <div className="social-link__status"></div>}
                        </a>
                    ))}
                </div>

                <div className="social-links__footer">
                    <div className="connection-status">
                        <div className="connection-dot"></div>
                        Network Status: Online
                    </div>
                    <div className="connection-status">
                        <div className="connection-dot"></div>
                        Active Connections: {socialMediaLinks.filter(link => link.isActive).length}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SocialLinks;